import { type FC } from "react";

import { type AvatarProps, AvatarWithLabel } from "../../Avatar";

export const UserAvatarAlpha: FC<AvatarProps> = (props) => {
	return <AvatarWithLabel {...props} />;
};
